module.exports = __webpack_public_path__ + "static/media/become-img-3.cc1a73db.png";